import WaitingRoomHeader from './WaitingRoomHeader';

export default WaitingRoomHeader;
